import { render, staticRenderFns } from "./RejectionDetailModal.vue?vue&type=template&id=88f16c5c&scoped=true&"
import script from "./RejectionDetailModal.vue?vue&type=script&lang=js&"
export * from "./RejectionDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f16c5c",
  null
  
)

export default component.exports